<template>
  <div class="resource-guarantee-card proto-card">
    <p class="rg-tip">
      处置本类事件所需的<strong>资源保障</strong>条目（可多份）：每条填写<strong>保障类型</strong>与<strong>保障内容</strong>。
    </p>
    <div class="section-head">
      <span class="section-title-bar">资源保障</span>
      <el-button type="primary" size="small" round icon="el-icon-plus" @click="addRow">
        新增
      </el-button>
    </div>
    <el-table
      :data="rows"
      border
      stripe
      size="small"
      class="proto-table"
      :empty-text="'暂无保障条目，请点击新增'"
    >
      <el-table-column label="保障类型" min-width="160">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.supportType"
            size="small"
            maxlength="200"
            placeholder="如：通信保障、医疗救护"
          />
        </template>
      </el-table-column>
      <el-table-column label="保障内容" min-width="320">
        <template slot-scope="{ row }">
          <el-input
            v-model="row.supportContent"
            type="textarea"
            :rows="3"
            maxlength="1000"
            placeholder="请描述具体保障措施与要求"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="88" align="center" fixed="right">
        <template slot-scope="{ $index }">
          <el-button type="text" size="small" class="btn-del" @click="removeRow($index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    infoMore: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      rows: []
    }
  },
  watch: {
    infoMore: {
      deep: true,
      immediate: true,
      handler () {
        this.init()
      }
    }
  },
  methods: {
    emptyRow () {
      return { supportType: '', supportContent: '' }
    },
    init () {
      const list = (this.infoMore && this.infoMore.resourceSupports) || []
      if (Array.isArray(list) && list.length > 0) {
        this.rows = list.map(r => ({
          supportType: r.supportType || '',
          supportContent: r.supportContent || ''
        }))
      } else {
        this.rows = []
      }
    },
    addRow () {
      this.rows.push(this.emptyRow())
    },
    removeRow (index) {
      this.rows.splice(index, 1)
    },
    echoData () {
      return this.rows.map(r => ({
        supportType: r.supportType,
        supportContent: r.supportContent
      }))
    }
  }
}
</script>

<style scoped lang="scss">
.resource-guarantee-card {
  padding: 18px 20px 20px;
  background: #fff;
  border: 1px solid #e6edf6;
  border-radius: 8px;
  box-shadow: 0 3px 12px rgba(31, 45, 61, 0.04);
}
.rg-tip {
  margin: 0 0 12px;
  padding: 10px 12px;
  font-size: 12px;
  color: #526276;
  line-height: 1.55;
  background: #f8fbff;
  border: 1px solid #e8f0fb;
  border-radius: 6px;
}
.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.section-title-bar {
  font-weight: 600;
  font-size: 15px;
  color: #1f2d3d;
  border-left: 3px solid #3b82f6;
  padding-left: 12px;
}
.proto-table {
  width: 100%;
  font-size: 13px;
  border-radius: 6px;
  overflow: hidden;
}
::v-deep .proto-table th {
  background: #f8fafc !important;
  color: #334155;
  font-weight: 600;
}
.btn-del {
  color: #ef4444;
}
</style>
